import * as React from "react";

export interface WithEnterModeHOCProps {
  enterMode?: "default" | "shift";
  onEnter?: () => void;
  onKeyDown?: (e: React.KeyboardEvent) => void;
}

const withEnterModeHOC =
  <OriginalProps extends {}>(Cmp: React.ComponentType<OriginalProps>) =>
  ({ enterMode, onEnter, onKeyDown, ...props }: OriginalProps & WithEnterModeHOCProps) => {
    const onKeyDownCallback = React.useCallback(
      (e: React.KeyboardEvent<HTMLTextAreaElement>) => {
        if (e.key === "Enter") {
          if (enterMode === "shift" && !e.shiftKey) {
            e.preventDefault();
          }

          if (onEnter) {
            switch (enterMode) {
              case "shift": {
                if (!e.shiftKey) onEnter();
                break;
              }
              default: {
                onEnter();
                break;
              }
            }
          }
        }

        onKeyDown && onKeyDown(e);
      },
      [onEnter, enterMode]
    );

    return <Cmp {...(props as any)} onKeyDown={onKeyDownCallback} />;
  };

export default withEnterModeHOC;
